import React from 'react'
import { Box, Button, Spacer } from '@truepill/react-capsule'
import { Edit } from 'react-feather'

export type EditHeaderProps = {
  isEditing: boolean
  onEdit: () => void
  onSave?: () => void
  onCancel: () => void
  title: string | React.ReactElement
}

export function EditHeader({ isEditing, onCancel, onEdit, onSave, title }: EditHeaderProps): JSX.Element {
  return (
    <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Box>{title}</Box>
      <Box css={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        {!isEditing ? (
          <Box>
            <Button
              size="xs"
              variant="primary-text"
              onClick={onEdit}
              css={{ display: 'flex', alignItems: 'center', paddingInline: 0 }}
            >
              Edit
              <Spacer size="xs" />
              <Edit size={16} />
            </Button>
          </Box>
        ) : (
          <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Button size="xs" variant="primary-text" onClick={onCancel} css={{ display: 'flex', alignItems: 'center' }}>
              Cancel
            </Button>
            <Button size="xs" type="submit" onClick={onSave} css={{ display: 'flex', alignItems: 'center' }}>
              Save
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export const useEditHeaderActions = ({ onSave }: { onSave?: () => void }) => {
  const [isEditing, setIsEditing] = React.useState(false)

  const onEdit = () => {
    setIsEditing(true)
  }

  const onCancel = () => {
    setIsEditing(false)
  }

  return { isEditing, onEdit, onSave, onCancel }
}
